import { useLocation, useNavigate } from "react-router";
import { Button } from "flowbite-react";
import { ArrowRight } from "lucide-react";
import { CartReservationTimer } from "@/features/cart/components/CartReservationTimer";
import type { CartResponse } from "@/features/cart/types/cart.type";
import { EuroFormat } from "@/shared/components/euroFormat";

type CartStickyBarProps = { cart: CartResponse };

export const CartStickyBar = ({ cart }: CartStickyBarProps) => {
  const location = useLocation();
  const navigate = useNavigate();
  const isShopPage = location.pathname.startsWith("/boutique");
  const isCartOrCheckoutPage = location.pathname.startsWith("/boutique/panier")
    || location.pathname.startsWith("/boutique/checkout");

  const itemLabel = cart.total_items > 1
    ? `${cart.total_items} articles`
    : `${cart.total_items} article`;

  if (!isShopPage || isCartOrCheckoutPage) return null;

  return (
    <div className="fixed bottom-0 right-0 z-50 px-2 sm:px-4 w-full lg:w-3xl">
      <div className="container mx-auto w-full">
        <div className="rounded-xl bg-white/95 dark:bg-gray-900/95 backdrop-blur border border-gray-200 dark:border-gray-700 shadow-lg">
          <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between px-4 py-3">
            <div className="flex flex-col gap-1">
              <div className="flex flex-wrap items-center gap-2 sm:gap-3">
                <div className="text-sm font-semibold text-gray-900 dark:text-white">
                  Mon panier
                </div>
                <div className="text-xs sm:text-sm text-gray-500 dark:text-gray-400">
                  {itemLabel}
                </div>
              </div>
              <CartReservationTimer cart={cart} variant="inline" />
            </div>

            <div className="flex flex-col sm:flex-row sm:items-center gap-3 sm:gap-4 w-full sm:w-auto whitespace-nowrap">
              <div className="flex items-center gap-2 sm:gap-3">
                <span className="text-xs uppercase tracking-wide text-gray-500 dark:text-gray-400">
                  Total
                </span>
                <span className="text-lg sm:text-xl font-bold text-primary-600 dark:text-primary-400">
                  <EuroFormat amount={cart.total_amount} />
                </span>
              </div>
              <Button
                color="primary"
                className="w-full sm:w-auto"
                onClick={() => navigate("/boutique/panier")}
              >
                Voir mon panier
                <ArrowRight className="ml-2 h-4 w-4" />
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

CartStickyBar.displayName = "CartStickyBar";
